var methodsTemplate = require('./publish.methods');
var _require = require('./publish.escape'),
  escapeHTML = _require.escapeHTML;
var passportTemplate = require('./passport.template');
function emailAddress(state) {
  return state.you && state.you.email ? state.you.email : '';
}
function emailPanel(state) {
  var email = state.verificationMethods.find(function (method) {
    return method.id === 'email';
  });
  if (email && email.status === 'verified') {
    return "<p class=\"verify-confirmed\">Your email has been verified.</p>";
  }
  var error = state.verifyError ? "<p class=\"note fail\">".concat(escapeHTML(state.verifyError), "</p>") : '';
  if (state.checking || email && email.status === 'sent') {
    var button = state.checking ? "<button type=\"button\" class=\"verify-action\" disabled aria-label=\"Checking\"><i class=\"fa-solid fa-spinner fa-spin\" aria-hidden=\"true\"></i></button>" : "<button type=\"button\" class=\"verify-action\" data-publish-action=\"submit-signature\">Confirm</button>";
    var dev = state.devCode ? "<p class=\"dev-code\">DEV MODE - Verification Code: <code>".concat(escapeHTML(state.devCode), "</code></p>") : '';
    return "\n      <p>Paste the cryptographic code from the email you receive into the box below.</p>\n      ".concat(dev, "\n      <div class=\"send-row\">\n        <input data-verify-signature type=\"text\" value=\"").concat(escapeHTML(state.pendingCode || ''), "\" aria-label=\"Cryptographic code\" autocomplete=\"off\"").concat(state.checking ? ' disabled' : '', " />\n        ").concat(button, "\n      </div>\n      ").concat(error, "\n    ");
  }
  return "\n    <p class=\"verify-lead\">Please verify your email address</p>\n    <div class=\"send-row\">\n      <input data-verify-email type=\"email\" value=\"".concat(escapeHTML(emailAddress(state)), "\" aria-label=\"Email address\" autocomplete=\"email\" />\n      <button type=\"button\" class=\"verify-action\" data-publish-action=\"send-email\">Send Email</button>\n    </div>\n    ").concat(error, "\n  ");
}
function photoPanel(state) {
  var photo = state.verificationMethods.find(function (method) {
    return method.id === 'photo';
  });
  if (photo && photo.status === 'verified') {
    var src = photoSource(photo.photo);
    var image = src ? "<img class=\"verified-photo\" src=\"".concat(escapeHTML(src), "\" alt=\"Verification photograph\">") : '';
    return "\n      <p class=\"heading\">Your photo has been verified.</p>\n      ".concat(image, "\n    ");
  }
  var method = photo || {
    description: ''
  };
  return "\n    <p class=\"heading\">Take a photo.</p>\n    <p>".concat(escapeHTML(method.description), "</p>\n    <div class=\"send-row\">\n      <button type=\"button\" class=\"verify-action\" data-publish-action=\"take-photo\">Take Photo</button>\n    </div>\n  ");
}
function passportPanel(state) {
  var method = state.verificationMethods.find(function (item) {
    return item.id === 'passport';
  });
  return "\n    <p class=\"heading\">Upload your passport identity page.</p>\n    <p>".concat(escapeHTML((method === null || method === void 0 ? void 0 : method.description) || ''), "</p>\n    ").concat(passportTemplate((method === null || method === void 0 ? void 0 : method.image) || '', state.passportError || ''), "\n  ");
}
function photoSource(value) {
  var src = String(value || '').trim();
  return src.startsWith('data:image/') ? src : '';
}
function verifySlide(state) {
  var upsell = state.verificationMethods.find(function (method) {
    return method.id === state.upsell;
  });
  var focus = state.focus || 'email';
  var method = state.verificationMethods.find(function (item) {
    return item.id === focus;
  });
  var panel = upsell ? "<p class=\"heading\">".concat(escapeHTML(upsell.description), "</p>") : focus === 'photo' ? photoPanel(state) : focus === 'passport' ? passportPanel(state) : focus === 'email' ? emailPanel(state) : "<p class=\"heading\">".concat(escapeHTML((method === null || method === void 0 ? void 0 : method.description) || 'This verification method is not available.'), "</p>");
  return {
    title: 'Before you sign this document, please verify your identity...',
    body: "\n      <div class=\"verify-flow\">\n        ".concat(methodsTemplate(state.verificationMethods, state.upsell || focus), "\n        <div class=\"detail\">\n          ").concat(panel, "\n        </div>\n      </div>\n    ")
  };
}
module.exports = verifySlide;